import React from 'react'

function Modal() {

  const closeModal = ()=>{
    const modal = document.querySelector('#Modal');
    const modalImage = document.querySelector('#Modal-image');
    modalImage.src = '';
    modal.close();

  }

  return (
    <dialog onClick={closeModal} id='Modal' className='photoViewer modal'>
        <button onClick={closeModal} aria-label='close modal' className="closeModal">
        <svg width="32px" height="32px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M9.16998 14.83L14.83 9.17004" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
<path d="M14.83 14.83L9.16998 9.17004" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
<path d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
</svg>
        </button>
        <img id='Modal-image' src="" alt="" className="Modal-image" />
    </dialog>
  )
}

export default Modal